import Vue from 'vue';

module.exports = {
    checked: false,

    async checkForUpdates() {
        this.checked = true;
        let response = await Vue.prototype.$axios.get('/latest-mobile-app-version');
        let latestAppVersion = response.data;
        console.log('LAV: ' + latestAppVersion)
        console.log('AV: ' + Vue.prototype.$appVersion)

        if (Vue.prototype.$appVersion !== latestAppVersion) { //update available
            let message = 'A new update for your app is available. We highly recommend you to update now for your app to be stable and get the latest features.';
            Vue.toasted.show(message, {
                theme: "toasted-primary",
                position: "top-center",
                duration: null,
                singleton: true,
                closeOnSwipe: false,
                fullWidth: false,
                action: [
                    {
                        text: 'Update',
                        onClick: (e, toastObject) => {
                            if (Vue.prototype.$platform === 'android') {
                                window.location.href = "market://details?id=com.things.al.esdp";
                            } else if (Vue.prototype.$platform === 'ios') {
                                window.location.href = "itms-apps://itunes.apple.com/app/id1459083281";
                            }

                            toastObject.goAway(0);
                        }
                    },
                    {
                        text: 'Later',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                ]
            });
        }

    },

    hasCheckedForUpdates() {
        return this.checked;
    }
};
